class cancelClass {
  static cancelRequest = {
    source: {
      token: null,
      cancel: null
    }
  };
}
export default cancelClass;
